import type { FaireProductEntity } from "../../entity_types/product";

export const p_qm726sqfwg: FaireProductEntity = {
  token: "p_qm726sqfwg",
  type: "product",
  name: "Herbs for Children's Health, 3rd Edition",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl:
    "https://cdn.faire.com/fastly/dbaef12d0550108e587aee00a570446bb47ab0765587ec72cc27cf7fffe60841.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.99,
  description:
    "Rosemary Gladstar, one of the most trusted names in natural medicine, shares dozens of easy-to-make, safe and effective herbal remedies and home care advice for addressing children's most common ailments. In this highly accessible handbook, best-selling author and herbal medicine expert Rosemary Gladstar offers her time-tested, safe and gentle natural recipes, along with simple care advice, for addressing children's everyday health needs. Parents of babies and toddlers will discover how easy it is create a home medicine cabinet of herbal remedies for addressing everything from colic to cradle cap, diaper rash, earaches, colds, cuts, teething, and more.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:12.749Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
